import type { PropsWithChildren } from 'react';

import { FormField, FormInput, SubForm } from '@/_components';

import type { UseCreateSKU } from './use-create-sku';

export function CreateSKU({ id, form, onSubmit, isPending, children }: PropsWithChildren<UseCreateSKU>) {
  return (
    <section className="col-span-12">
      <SubForm id={`create-sku-${id}`} {...form} onSubmit={onSubmit} isSubmitting={isPending}>
        <FormField
          control={form.control}
          name="sku"
          render={({ field: { value, onChange } }) => (
            <div className="flex w-full flex-1">
              <FormInput
                formItemClassName="flex-1"
                value={value}
                onChange={onChange}
                label="New SKU"
                name="sku"
                className="w-full flex-1"
                labelProps={{ className: 'w-[calc(100%_+_1.75rem)]' }}
              />
              {children}
            </div>
          )}
        />
      </SubForm>
    </section>
  );
}
